@if (visible()) {
  <div class="ws-sync-overlay">
    @if (pending()) {
      <div class="ws-sync-overlay__spinner" aria-hidden="true"></div>
      <h3 class="ws-sync-overlay__title so-text-2-bold">
        {{ 'ws_sync_overlay_loading_title' | translated : 'Sincronizando datos' }}
      </h3>
      <p class="ws-sync-overlay__description so-text-3">
        {{ 'ws_sync_overlay_loading_description' | translated : 'Estamos descargando la información desde el WS de la marca. Esto puede tardar unos segundos.' }}
      </p>
    } @else {
      <so-svg-icon-ui [name]="'sync'" [size]="64" [color]="'--so-primary'" />
      <h3 class="ws-sync-overlay__title so-text-2-bold">
        {{ 'ws_sync_overlay_title' | translated : 'Información sincronizada' }}
      </h3>
      <p class="ws-sync-overlay__description so-text-3">
        {{ 'ws_sync_overlay_description' | translated : 'Esta información se sincroniza automáticamente desde el WS de la Marca' }}
      </p>
      <button type="button" class="ws-sync-overlay__logs-btn" (click)="openLogs()">
        {{ 'ws_sync_logs_button' | translated : 'Ver logs de sincronización' }}
      </button>
    }
  </div>
}
